<!--
 * @Author: hanchunxuan 1627047609@qq.com
 * @Date: 2023-10-08 09:39:55
 * @LastEditors: hanchunxuan 1627047609@qq.com
 * @LastEditTime: 2023-10-14 11:27:27
 * @FilePath: \1008\zonghoutai-front\src\components\Head.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="myMenu">
    <div class="headBox">
     <!-- <div class="head_logo">
        <img src="@/assets/img/home/logo1.png" alt="" style="width:170px;height:40px;position: relative;top: 5px;">
      </div> -->
      <div class="head_desc">
       数智营销推广平台    <br />
       企业数字化转型——内外贸营销和品牌推广
      </div>
      <div class="head_center">
         <img src="@/assets/img/home/centerLogo.png" alt="" >
      </div>
      <div class="head_user">
        <el-dropdown>
          <div class="el-dropdown-link">
            <img src="@/assets/img/home/nameIcon.png" alt="" />
            <div class="head_user_title">{{ title }}</div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item icon="el-icon-user">个人中心</el-dropdown-item>
        <el-dropdown-item icon="el-icon-setting">修改密码</el-dropdown-item> -->
            <el-dropdown-item icon="el-icon-switch-button"
              ><span @click="out">退出登录</span></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
  
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      title: "",
    };
  },
  created(){
	  console.log(localStorage.getItem('userInfo'));
   this.title=JSON.parse(localStorage.getItem('userInfo')).username
  },
  methods: {
    ...mapMutations("user", ["setToken", "setUserName"]),

    out() {
      this.$confirm("确定注销并退出系统吗？", "提示", {
        confirmButtonText: "退出",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          console.log(111);
          let token = localStorage.getItem("mytoken") || "";
          this.$http.logout({ token }).then((res) => {
            if (res.data.code == 200) {
              this.$router.push("/login");
              localStorage.removeItem("mytoken");
              localStorage.removeItem("userInfo");
              this.setToken("");
              this.setUserName("");
              console.log(this.$store);
            } else {
              this.$message.error(res.data.data.msg);
            }
          });
        })
        .catch(() => {});
      // this.$http.logout({token}).then(res=>{

      // })
    },
  },
};
</script>

<style lang='scss' scoped>
$bgColor:  rgb(20,49,198);;
.myMenu {
  background: $bgColor;
  border-radius: 0px 0px 20px 20px;
}
.headBox {
  display: flex;
  width: 100%;
  height: 92px;
  background: url("@/assets/img/menu.png") no-repeat;
  border-radius: 0px 0px 20px 20px;
  opacity: 1;
  // padding-top: 22px;
  padding: 0 40px;
  align-items: center;
  box-sizing: border-box;
  .head_logo {
    font-size: 36px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #dadcf4;
    letter-spacing: 5px;
    -webkit-background-clip: text;
  }
  .head_center{
    flex: 2;
    text-align: center;
    img{
      position: relative;
      left: 50px;
      width: 279px;
      height: 53px;
    }
  }
  .head_desc {
    margin-left: 20px;
    // width: 295px;
    // height: 42px;
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #babde5;
    // line-height: 19px;
    letter-spacing: 2px;
    -webkit-background-clip: text;
  }
  .head_user {
    flex: 1;
    display: flex;
    align-items: center;
    // padding-right: 30px;
    justify-content: flex-end;
  }
  img {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }
  .head_user_title {
    color:#fff;
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  }
  .el-dropdown-link {
    display: flex;
    align-items: center;
  }
}
::v-deep .el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled) {
  &:hover {
    border: none !important;
    background-color: #8d1d86 !important;
    color: #fff;
  }
}
</style>